angular.module('controllers').controller('paymentMethodController', ['$scope', '$rootScope', '$controller',
	function ($scope, $rootScope, $controller) {
		$rootScope.path = '/payment-method';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'payment-method';
		$scope.pathTemplate = 'clients/paymentmethods';
		$scope.title = 'Metode de plata';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'payment_method_name';
		$scope.defaultItem = 10;
		$rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'payment_method_name':{'label':'Nume', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals = [];
		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'payment_method_name';

		$scope.additionals['functionResult']= function(ev, data) {
			if (!angular.isUndefined($scope.modelData.payment_method_name)) {
				$scope.modelData.payment_method_name = $scope.modelData.payment_method_name.toLowerCase();
			}
			if (!angular.isUndefined($scope.modelsData)) {
				angular.forEach($scope.modelsData, function (item, key) {
					if (!angular.isUndefined($scope.modelsData[key].payment_method_name)) {
						$scope.modelsData[key].payment_method_name = $scope.modelsData[key].payment_method_name.toLowerCase();
					}
				});
			}
		}

		$scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);


	}]
);
